import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { MatchingAnalyticsActions } from './matching-analytics.actions';
import { AnalyticsQueryParams } from '@app/core/api/analytics-shared';
import {
  selectMatchingOverview,
  selectMatchingLoading,
  selectMatchingError
} from './matching-analytics.selectors';

@Injectable({
  providedIn: 'root'
})
export class MatchingAnalyticsFacade {
  private readonly store = inject(Store);

  readonly overview$ = this.store.select(selectMatchingOverview);
  readonly loading$ = this.store.select(selectMatchingLoading);
  readonly error$ = this.store.select(selectMatchingError);

  loadOverview(params: AnalyticsQueryParams): void {
    this.store.dispatch(MatchingAnalyticsActions.loadOverview({ params }));
  }

  clearState(): void {
    this.store.dispatch(MatchingAnalyticsActions.clearMatchingAnalyticsState());
  }
}
